import axios from 'axios';

let Rdvbien : any = {};
Rdvbien.submitForm = async (data:any) =>{
    
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/bien/send/rdv`, data)
}

export default Rdvbien;